/**
 * @title compareProducts.js: Sub-module for Global pages
 * @description This module handles the states of the compare Products selection box
 * @dependency 
 */
define([], function() {	
	
	"use strict";
	
	var compareProducts = {
			
		error : false,
			
		getCompare : function(){
			var compareString = localStorage.getItem("compare");
			
			if(compareString == null || typeof compareString == "undefined"){
				return [];
			}
			
			var compareArray = JSON.parse(compareString);
			
			// read the array and sanitize the values for compareImage
			for (var i = 0; i < compareArray.length; i++) {
				compareArray[i].compareImage = encodeURI(compareArray[i].compareImage);
				if (compareArray[i].alt != "" && compareArray[i].alt != undefined) {
					compareArray[i].alt = compareArray[i].alt.replace(/\\"/g, " inch").replace(/\\'/g, "'") + ' image';
				}
			}
			
			return compareArray;
		},
		
		clearAll : function(){
			this.clearCheckboxes();
			this.setCompare([]);
			this.draw();
			COSTCO.util.announceSRMessage(messages.ALL_ITEMS_REMOVED); 
		},
		
		clearCheckboxes : function(){
			var compareArray = this.getCompare();
			for(var i=0; i<compareArray.length;i++){
				this.uncheckCheckbox(compareArray[i].partNumber);
			}
		},
		
		setCompare : function(json){
			
			var jsonString = JSON.stringify(json);	
			localStorage.setItem("compare", jsonString);
		},
		
		hideCompare : function(){
			this.hideError();
			$('#compare-box-products').addClass('closed');
			$('#compare-box-products [tabindex=0]').attr('tabindex', '-1');
			if(localStorage){
				localStorage.setItem('compareMin','false');
			}
		},
		
		minimizeCompare : function(){
			this.hideError();
			$('#compare-box-products').addClass('minimized');
			$('#minimize-text').html(cpStatic.showText);
			$('#compare-minimize .co-chevron-right').removeClass('rotate90').addClass('rotate270');
			$('#compare-box-products [tabindex = 0]').attr('tabindex', '-1');
			$('#compare-minimize').attr('tabindex','0');
			if(localStorage){
				localStorage.setItem('compareMin','true');
			}
		},
		
		showCompare : function(){
			this.unhide();
			$('#compare-box-products,#compare-box-container,#compare-box-products').removeClass('minimized').removeClass('closed');
			$('#minimize-text').html(cpStatic.hideText);
			$('#compare-minimize .co-chevron-right').removeClass('rotate270').addClass('rotate90');
			$('#compare-box-products [tabindex=-1]').attr('tabindex','0');
			if(localStorage){
				localStorage.setItem('compareMin','false');
			}
		},
		
		unhide : function(){
			$('#compare-box-container').removeClass('hide');
			$('#compare-box-products [tabindex=-1]').attr('tabindex','0');
		},
		
		isPageComparable : function(){
			return ($('#compare-box-container').length > 0 && $('.compare-container').length > 0);
		},
		addAttributes : function() {
			$('#compare-box-products').attr('role', 'region');
			$('#compare-box-products').attr('aria-label', 'Compare Products');
			$('#compare-box-products').attr('id', 'compare-box-products');
		},
			
		init : function() {
			
			if(!this.isPageComparable()){
				console.log('Not a comparable page');
				return;
			}else{
				let compArray = this.getCompare();
				if (compArray != undefined && compArray.length != 0){
					this.unhide();
				}
			}
		
			console.log('Initializing Compare Products');
			this.initMinmize();
			this.initCheckboxes();
			this.addAttributes();
			this.draw();
			
		},
		
		isMinimized : function(){
			var minState = localStorage.getItem('compareMin');
			
			if(typeof minState == "undefined" || minState == null){
				return false;
			}
			
			if(minState == "true"){
				return true;
			}
			return false;
		},
		
		initMinmize : function(){
			if(this.isMinimized()){
				this.minimizeCompare();
			}
		},
		
		initCheckboxes : function(){
			
			$('input[name="compare-product"]').prop('checked',false);
			
			var compareArray = this.getCompare();
			for(var i=0; i<compareArray.length; i++){
				this.checkCheckbox(compareArray[i].partNumber);
			}
			
		},
		
		checkCheckbox : function(partNumber){
			$('#compare_' + partNumber).prop('checked',true)
		},
		
		uncheckCheckbox : function(partNumber){
			if ($('#compare_' + partNumber).length > 0) {
				$('#compare_' + partNumber).prop('checked',false);
			} else if ($('#compare_sponsored_' + partNumber).length > 0) {
				$('#compare_sponsored_' + partNumber).prop('checked',false);
			} else {
				console.log('Error unchecking checkbox there is no item with this part number. ' + partNumber);
			}
		},
		
		isItemCompared : function(partNumber){
			
			var compareJson = this.getCompare();
			for(var i=0; i<compareJson.length; i++){
				if(partNumber == compareJson[i].partNumber){
					return true;
				}
			}
			
			return false;
			
		},
		
		pushItem : function(partNumber, image, description, isFsaChd){
			
			var compareObj = { partNumber : partNumber, compareImage : image, alt : description, isFsaOrChd : isFsaChd};
			
			if(localStorage){
				localStorage.setItem('compareMin','false');
			}
			
			var compareArray = this.getCompare();
			if(compareArray.length == 4){
				COSTCO.compareProducts.error = true;
				this.uncheckCheckbox(partNumber);
			}else{
				compareArray.push(compareObj);
				this.setCompare(compareArray);
			}
			
		},
		
		removeItem : function(partNumber){
			
			this.hideError();
			
			var compareJson = this.getCompare();
			var index = -1;
			for(var i=0; i<compareJson.length; i++){
				if(partNumber == compareJson[i].partNumber){
					index = i;
				}
			}
			
			if(index > -1){
				this.uncheckCheckbox(compareJson[index].partNumber);
				compareJson.splice(index, 1);
				this.setCompare(compareJson);
			}			
			
		},
		
		toggleItem : function(partNumber, image, object, isFsaChd){
			var description = $(object).attr("data-description");
			if (description != undefined && description != "undefined" && description != null) {
				description = description.replace(/(['"&:;])/g, "\\$1");	
			}			
			if(this.isItemCompared(partNumber)){
				this.removeItem(partNumber);
			}else{
				this.pushItem(partNumber, image, description, isFsaChd);
			}
			this.draw();
			COSTCO.util.announceSRMessage(messages.ITEM_REMOVED);
		},
		
		toggleMinimize : function(){
			
			if($('#compare-box-products').hasClass('minimized')){
				this.showCompare();
				$('#compare-minimize').attr('aria-expanded', 'true');
				$('#compare-box-row, .compare-buttons-container').attr('aria-hidden', 'false');
			}else{
				this.minimizeCompare();
				$('#compare-minimize').attr('aria-expanded', 'false');
				$('#compare-box-row, .compare-buttons-container').attr('aria-hidden', 'true');
			}
			
		},
		
		toggleMinimizeKey : function(e){
			//if event is enter key
			if(e.which === 13) {
				COSTCO.compareProducts.toggleMinimize();
			}
		},
		hideError : function(){
			COSTCO.compareProducts.error = false;
			$('#compare-box-products,#compare-error-row').removeClass('error-state');
			$('#compare-error-row').html('');
		},
		
		showError : function(){
			$('#compare-box-products,#compare-error-row').addClass('error-state');
			$('#compare-error-row').html(cpStatic.itemAddErrorText);
		},
		
		draw : function(){
			
			var compareJson = this.getCompare();
			if(compareJson == null || compareJson.length == 0){
				this.hideCompare();
			}else if (this.isMinimized()){
				this.minimizeCompare();
			}else{
				this.showCompare();
			}
			
			if(COSTCO.compareProducts.error){
				this.showError();
			}else{
				this.hideError();
			}
			
			var compareArray = this.getCompare();
			var totalSpots = 4; // 1 based indices around these parts
			var totalItems = compareArray.length;
			var html = '';
			var automation = '';
			
			for(var i=0; i<totalItems; i++){
				if(typeof compareArray[i].compareImage == "undefined"){
					compareArray[i].compareImage = cpStatic.errorDomain + "images/unavailable_350.png";
				}else if(!COSTCO.util.isBusinessDelivery() && compareArray[i].compareImage.indexOf('847') < 0 && compareArray[i].compareImage.indexOf('894') < 0 ){
					compareArray[i].compareImage = cpStatic.errorDomain + "images/unavailable_350.png";
				}
				if(compareArray[i].isFsaOrChd == 'true'){
					html += COSTCO.util.tmpl('tmpl_comparable_product_fsachd',compareArray[i]);
				}else {
					html += COSTCO.util.tmpl('tmpl_comparable_product',compareArray[i]);
				}
			}
			
			for(var i=0; i<totalSpots - totalItems; i++){
				html += COSTCO.util.tmpl('tmpl_empty_product',{'automationId' : automation +i});
			}
			
			this.fill(html);
			
		},
		
		fill : function(html){
			$('#compare-box-row').html(html);
		},
		
		compare : function(){
			
			var COMPARE_URL = "/CompareProductsDisplay", PART_NUMBER_PARAM = "?partNumbers=";
			
			var compareArray = this.getCompare();
			var partNumbers = $(compareArray).map(function() { return this.partNumber; }).get().join(',');
			var url = COMPARE_URL + PART_NUMBER_PARAM + partNumbers;
			
			window.location = url;
			
		}
		
	}//end compareProducts object

	function getScrubbedUrl(urltoscrub)
	{
		if(urltoscrub!=null && urltoscrub.indexOf('.product.')!= -1) {
			var sarray = urltoscrub.split('.product.');
			if(sarray == null ) {
				return "";
			} else {
				return '.product.' + sarray[1];	
			}
		} else {
			return urltoscrub;
		}
	}

	// Expose compareProducts to the global scope.
    if (typeof window.COSTCO === "undefined") {
        window.COSTCO = new Object();
    } 
	
    window.COSTCO.compareProducts = compareProducts;
		
	return compareProducts;
    
});


// WEBPACK FOOTER //
// ./js/browse/compareproducts.js